import { CheckboxItemChip } from '@vk-hr-tek/ui/CheckboxList';
import { Icon } from '@vk-hr-tek/ui/Icon';

import { EmployeeManager } from '@app/gen/user';

import { SubstituteType } from '../types';

export const SMS_CODE_LENGTH = 6;

export const USER_CERTIFICATE_TOPIC = 'user.certificate';

export const USER_CHANGED_MESSAGE_TYPE = 'user_changed';

export const EMPLOYEE_MANAGERS_PRIORITY: Record<
  EmployeeManager['type'],
  number
> = {
  legal: 1,
  operational: 2,
  functional: 3,
};

export const RU_STORE_LINK = 'https://www.rustore.ru/catalog/app/ru.vk.hrtek';
export const APP_GALLERY_LINK =
  'https://appgallery.huawei.com/#/app/C107531675';

interface SubstituteTypeOption {
  value: SubstituteType;
  label: string;
}

export const TYPES_OF_SUBSTITUTE: SubstituteTypeOption[] = [
  { value: 'permanent', label: 'Постоянный' },
  { value: 'temporary', label: 'Временный' },
];

export const SUBSTITUTE_TYPE_CHIP: Record<SubstituteType, CheckboxItemChip> = {
  permanent: {
    startIcon: <Icon name="calendar_outline" size="16" />,
    color: 'darkgray',
    label: 'Постоянный',
  },
  temporary: {
    color: 'orange',
    label: 'Временный',
  },
};
